import { Publisher } from '@/model';
import PublishersView from '@/views/PublishersView.vue';
import Vue, { VNode } from 'vue';
import publishers from '@/store/publisher';

export default Vue.extend({
  name: 'PublishersController',
  components: {
    PublishersView,
  },

  data() {
    return {
      loading: false,
    };
  },

  mounted() {
    this.load();
  },

  methods: {
    async load() {
      this.loading = true;
      publishers.dispatch.all();
      this.loading = false;
    },
    async save(pub: Publisher) {
      this.loading = true;
      publishers.dispatch.save(pub);
      this.loading = false;
    },
  },
  render(create): VNode {
    return create(
      PublishersView, {
        props: {
          loading: this.loading,
          publishers: publishers.state.publishers,
        },
        on: {
          save: this.save,
          load: this.load,
        },
      },
    );
  },
});
